import React from "react";
import "./style.scss";

export type EstablishHeaderProps = {
  headerTitle: string;
  batchDangerWord?: string;
  batchAnyWord?: string;
};

export const EstablishHeader = (props: EstablishHeaderProps) => {
  const { headerTitle, batchDangerWord, batchAnyWord } = props;
  return (
    <div className="establishHeader">
      <span className="establishHeader_title">{headerTitle}</span>
      {/* TODO:バッチのスタイル改修 */}
      {batchDangerWord && (
        <div className="establishHeader_batchDanger ">{batchDangerWord}</div>
      )}
      {batchAnyWord && (
        <div className="establishHeader_batchAny ">{batchAnyWord}</div>
      )}
    </div>
  );
};
